import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators} from 'redux'
import XLSX from 'xlsx';
import _ from 'lodash'
import {Tab, Table, Icon, Button, Modal} from 'semantic-ui-react'
import {
    setPricingModelInStore, deletePricing
} from '../../../actions/relation'
import InventoryPricingModalForm from '../../forms/relations/InventoryPricingModal'
import PDFDisplay from '../../utils/DisplayPDF'
import accounting from 'accounting';
import {api} from '../../../api'

class PricingTab extends Component {
    constructor() {
        super();
        this.state = {
            formOpen: false,
            pdfViewer: false,
            base64String: ""
        }
    }
    //access router
    //this.props.history.push('/dashboard')
    onPricingEditClick = (pricing) => {
        this.props.setPricingModelInStore(pricing, this.props.relationId);
        this.setState({
            formOpen: true
        })
    }

    onAddNewClick = () => {
        this.props.setPricingModelInStore({}, this.props.relationId);
                this.setState({
            formOpen: true
        })
    }

    onDeleteClick = (price) => {
        this.props.deletePricing(this.props.jwt, price.pivot.relation_id, price.pivot.inventory_id);
    }

    getCurrentlyAssociatedIds = () => {
        const {prices} = this.props;
        const except = [];
        _.each(prices, price => {
            except.push(price.id)
        })
        return except;
    }

    renderPricingPDF = () => {
        const params = {
            docType: 'customer-pricing',
            docId: this.props.relationId
        };
        api.pdf(this.props.jwt, params).then(res => {
            const {data} = res.data;
            this.setState({
                pdfViewer: true,
                base64String: data
            });
        })
    }

    onPdfModalClose = () => {
        this.setState({
            pdfViewer: false
        });
    }

    onGenerateShopifyCsv = () => {
        const {relationId,prices} = this.props;
        const tag = "dls-"+relationId;
        const wb = XLSX.utils.book_new();
        const data = [
            ["Handle","SKU","Price Type",tag]
        ];
        // console.log(prices);
        // return null;
        
        _.each(prices, p => {
            if (p.shopify_id > 0) {
                if (p.pivot) {
                    data.push([
                        p.slug,p.sku,"$",parseFloat(p.pivot.special_price).toFixed(2)
                    ]);
                }
            } else {
                if (p.spr && p.spr.shopify_id) {
                    data.push([
                        p.spr.slug,p.sku,"$",parseFloat(p.pivot.special_price).toFixed(2)
                    ]);
                }
            }
        });
        if (data.length > 1) {
            const sheet = XLSX.utils.aoa_to_sheet(data);
            XLSX.utils.book_append_sheet(wb, sheet,'Sheet1');
            XLSX.writeFile(wb, tag+'.csv');
        }
    }

    isShopify = (p) => {
        if (p.shopify_id) {
            return true;
        }

        if (p.spr && p.spr.shopify_id) {
            return true;
        }

        return false;
    }

    render() {
        const {prices, type} = this.props;
        return (
            <Tab.Pane>
                <Table compact>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Shopify</Table.HeaderCell>
                            <Table.HeaderCell>Original SKU</Table.HeaderCell>
                            <Table.HeaderCell>{_.upperFirst(type)} SKU</Table.HeaderCell>
                            <Table.HeaderCell>{_.upperFirst(type)} Name</Table.HeaderCell>
                            <Table.HeaderCell>{type === 'customer' ? 'Original Price' : 'Original Cost'}</Table.HeaderCell>
                            <Table.HeaderCell>{type === 'customer' ? `Customer Price` : 'Vendor Cost'}</Table.HeaderCell>
                            <Table.HeaderCell>Delete</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {_.isArray(prices) ? prices.map( i => {
                            return (
                                <Table.Row key={i.id}>
                                    <Table.Cell>
                                        {this.isShopify(i) ? "Yes" : "No"}
                                    </Table.Cell>
                                    <Table.Cell>
                                        <a href="javascript:;" onClick={() => {this.onPricingEditClick(i)}}>
                                        {i.sku}
                                        </a>
                                    </Table.Cell>
                                    <Table.Cell>{i.pivot.special_sku}</Table.Cell>
                                    <Table.Cell>
                                        {i.pivot.special_name}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {type === 'customer' ? accounting.formatMoney(i.selling) : accounting.formatMoney(i.cost)}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {accounting.formatMoney(i.pivot.special_price)}
                                    </Table.Cell>
                                    <Table.Cell>
                                        <a href="javascript:;" onClick={() => {this.onDeleteClick(i)}}>
                                            <Icon name='delete' />
                                        </a>
                                    </Table.Cell>
                                </Table.Row>
                            )
                        }): null}
                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell colSpan='7'>
                                <Button size='mini' 
                                    floated='right' 
                                    onClick={() => {this.onAddNewClick()}}
                                    color='teal' as={Button}>Add New</Button>
                                <Button size='mini' 
                                    floated='right' 
                                    onClick={() => {this.onGenerateShopifyCsv()}}
                                    color='blue' as={Button}>Shopify Pricing CSV</Button>
                                <Button size="mini"
                                    floated="right"
                                    onClick={() => {
                                        this.renderPricingPDF()
                                    }}
                                    color='blue'
                                >PDF</Button>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                </Table>
                <InventoryPricingModalForm 
                    isOpen={this.state.formOpen}
                    onModalClose={() => {this.setState({formOpen: false})}}
                    type={type}
                    exceptIds={this.getCurrentlyAssociatedIds() ? this.getCurrentlyAssociatedIds() : []}
                />
                <Modal size='large' open={this.state.pdfViewer} onClose={this.onPdfModalClose} closeOnDimmerClick={false}>
                        <Modal.Content>
                            <div className="row" style={{marginBottom: '10px'}}>
                                <div className="col-md-12">
                                    <Button size='mini' color='teal' floated='right' onClick={() => {this.onPdfModalClose()}}>Close</Button>
                                </div>
                            </div>
                            <PDFDisplay pdf={this.state.base64String} />
                        </Modal.Content>
                    </Modal>
            </Tab.Pane>
        )
    }
}

PricingTab.propTypes = {
    prices: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired,
    relationId: PropTypes.number.isRequired,
    setPricingModelInStore: PropTypes.func.isRequired,
    deletePricing: PropTypes.func.isRequired,
    jwt: PropTypes.string.isRequired
};

function mapStateToProps(state) {
    return {
        jwt: state.auth.jwt
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setPricingModelInStore, deletePricing
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PricingTab)


// WEBPACK FOOTER //
// ./src/components/relations/parts/PricingTab.js